/* The photograph stays intact. Native scrolling moves a single camera crop; no autoplay or scroll interception. */
(() => {
  const init = root => {
    if (root.dataset.journeyReady) return;
    root.dataset.journeyReady = 'true';
    const stage = root.querySelector('.home-journey-stage');
    const button = root.querySelector('[data-home-motion]');
    const media = matchMedia('(min-width:960px) and (min-height:600px) and (prefers-reduced-motion:no-preference)');
    let frame = 0;
    let paused = false;
    let visible = true;
    let start = 0;
    let distance = 1;
    const clamp = value => Math.max(0, Math.min(1, value));
    const render = () => {
      frame = 0;
      if (!media.matches) return;
      const progress = clamp((window.scrollY - start) / distance);
      // A gentle ease-out reaches the full room before the next section arrives.
      const camera = 1 - Math.pow(1 - clamp(progress / .92), 2);
      root.style.setProperty('--journey-scale', paused ? '1' : String(1.42 - .42 * camera));
      root.style.setProperty('--journey-progress', String(progress));
    };
    const schedule = () => { if (visible && media.matches && !frame) frame = requestAnimationFrame(render); };
    const measure = () => {
      root.classList.toggle('is-animated', media.matches);
      button.hidden = !media.matches;
      if (!media.matches) {
        root.style.removeProperty('--journey-scale');
        root.style.removeProperty('--journey-progress');
        return;
      }
      const header = parseFloat(getComputedStyle(root).getPropertyValue('--journey-header')) || 78;
      start = root.getBoundingClientRect().top + window.scrollY - header;
      distance = Math.max(1, root.offsetHeight - stage.offsetHeight);
      schedule();
    };
    const toggleMotion = () => {
      paused = !paused;
      button.setAttribute('aria-pressed', String(paused));
      button.setAttribute('aria-label', paused ? button.dataset.motionLabel : button.dataset.stillLabel);
      schedule();
    };
    const observer = new IntersectionObserver(entries => {
      visible = entries[0].isIntersecting;
      if (visible) schedule();
    });
    observer.observe(root);
    button.addEventListener('click', toggleMotion);
    window.addEventListener('scroll', schedule, { passive:true });
    window.addEventListener('resize', measure);
    window.addEventListener('pageshow', measure);
    media.addEventListener('change', measure);
    measure();
    root.cleanupJourney = () => {
      cancelAnimationFrame(frame);
      observer.disconnect();
      button.removeEventListener('click', toggleMotion);
      window.removeEventListener('scroll', schedule);
      window.removeEventListener('resize', measure);
      window.removeEventListener('pageshow', measure);
      media.removeEventListener('change', measure);
    };
  };
  document.querySelectorAll('[data-home-journey]').forEach(init);
  document.addEventListener('shopify:section:load', event => event.target.querySelectorAll('[data-home-journey]').forEach(init));
  document.addEventListener('shopify:section:unload', event => event.target.querySelectorAll('[data-home-journey]').forEach(root => root.cleanupJourney?.()));
})();
